import { render, staticRenderFns } from "./PropertyEditor.vue?vue&type=template&id=588dc96c&scoped=true"
import script from "./PropertyEditor.vue?vue&type=script&lang=js"
export * from "./PropertyEditor.vue?vue&type=script&lang=js"
import style0 from "./PropertyEditor.vue?vue&type=style&index=0&id=588dc96c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588dc96c",
  null
  
)

export default component.exports